import { ValueComponent } from "components/components/Component";
import { SimpleOutputBaseDefinition, DateOutputBaseComponent } from "components/output/baseOutputDefinition";
import { DateTimeRangeData, DateTimeRangeString } from "components/output/baseHTMLElementOutput";
import sislogUserGlobals from "components/UserGlobals";
import template from "./dateTimeRange.hbs";
import { DateTimeRangeOutputElement, initDateTimeRangeOutputWebComponent } from "./dateTimeRangeElement";

initDateTimeRangeOutputWebComponent();

export class DateTimeRangeOutput extends DateOutputBaseComponent<DateTimeRangeOutputDefinition> implements ValueComponent {

    public readonly componentType: string = "dateTimeRangeOutput";

    private element: DateTimeRangeOutputElement;

    constructor(schema: DateTimeRangeOutputDefinition) {
        super(schema);
    }

    public render(): Element {
        this.renderTemplate();
        this.bindEvents();
        return this.view;
    }

    public renderTemplate(): Element {
        let objStyle: any = this.generateSytleAttribute();
        let params = { ...objStyle, ...{ id: this.id, language: sislogUserGlobals.language } };
        return super.renderTemplate(template, params);
    }

    private bindEvents(): void {

        this.element = this.view.querySelector("s6-date-time-range-output");

        this.genericBindEvents(this.element);
    }

    public getValue(): DateTimeRangeData {
        return this.element.data;
    }

    public value(v: DateTimeRangeString | DateTimeRangeData) {
        if (v != null) {
            let from;
            if (v.from != null) {
                from = new Date(v.from);
            }
            let to;
            if (v.to != null) {
                to = new Date(v.to);
            }
            this.element.data = {
                from,
                to,
            };
        } else {
            this.element.data = null;
        }
    }
}

export interface DateTimeRangeOutputDefinition extends SimpleOutputBaseDefinition {
}
